import LocalizedStrings from 'react-localization';

import { Colors, ClientLanguage, getClientLanguageAsString } from "../Api"
import { CustomLink } from "./StyledComponents"

let locStrings = new LocalizedStrings({
    de:
    {
        footerLegalNotice:"Impressum",
        footerDataSecurity:"Datenschutz"
    },
    en: 
    {
        footerLegalNotice:"Legal Notice",
        footerDataSecurity:"Data Security"
    }
});

interface LegalsProps {
    colors: Colors
    legalNoticeUrl?: string
    dataSecurityUrl?: string
    clientLanguage?: ClientLanguage
}


export const Legals = (props: LegalsProps) => {

    setLanguage();

    function setLanguage(): void {
        switch(props.clientLanguage) { 
            case ClientLanguage.German: { 
               locStrings.setLanguage('de');
               break; 
            } 
            case ClientLanguage.English: { 
               locStrings.setLanguage('en'); 
               break; 
            } 
            // Otherwise "props.clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
        } 
    }

    return (
        <>
            {props.legalNoticeUrl && <CustomLink className={"ListDetailsLinkLegalNotice"} href={props.legalNoticeUrl} target="_blank" colors={props.colors} size='sm'>{locStrings.footerLegalNotice}</CustomLink>}
            {props.legalNoticeUrl && props.dataSecurityUrl && <>|</>}
            {props.dataSecurityUrl && <CustomLink className={"ListDetailsLinkDataSecurity"} href={props.dataSecurityUrl} target="_blank" colors={props.colors} size='sm'>{locStrings.footerDataSecurity}</CustomLink>}
        </>
    )
}